/**
 * @generated SignedSource<<43b4d58b568043b5f59960456f5d1efa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InviteActions_Booking$data = {
  readonly id: string;
  readonly shareUrl: string | null | undefined;
  readonly " $fragmentType": "InviteActions_Booking";
};
export type InviteActions_Booking$key = {
  readonly " $data"?: InviteActions_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"InviteActions_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InviteActions_Booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shareUrl",
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "6faded3e7b20ae0e00b36e9fca9f5718";

export default node;
